import React from 'react';
import PropTypes from 'prop-types';

// Lucide-derived (MIT) outline shape drawn in the Heroicons style — 24px
// viewBox, stroke=currentColor, strokeWidth=1.5, no fill. Heroicons doesn't
// ship a handshake glyph and the Figma source uses Font Awesome Pro Light.

HandshakeIcon.propTypes = {
  className: PropTypes.string
};

export default function HandshakeIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="m11 17 2 2a1 1 0 1 0 3-3" />
      <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-1.41-1.41l2.62-2.62a6 6 0 0 1 8.49 8.49" />
      <path d="m18 11-1.9-1.9" />
      <path d="M3.6 13.5 9 19a1 1 0 0 0 1.4-1.4L9 16.6" />
      <path d="m4 14 2.5-2.5a3 3 0 0 0 0-4.24L5.5 6.25 2.5 9.25" />
    </svg>
  );
}
